import { useEffect } from "react";
import { usePageTitle } from "../contexts/PageTitleContext";

const useSetPageTitle = (title) => {
  const { setPageTitle } = usePageTitle();
  useEffect(() => {
    setPageTitle(title);
    return () => setPageTitle(null);
  }, [title, setPageTitle]);
};

export default useSetPageTitle;
